<div class="dialogue-content">
    <div class="mat-dialogue-header">
        <a class="close-btn" mat-dialog-close><i class="ri-close-fill"></i></a>
    </div>
    <mat-dialog-content>
        <div class="text-center">
            <form novalidate>
                <img src="assets/images/logout.svg" class="mb-4 m-auto d-table" />
                <h5 class="text-primary">Log out</h5>
                <p>Are you sure you want to log out?</p>
                <div class="d-flex align-items-center mt-4 flex-wrap justify-content-center gap-3">
                    <button matButton="filled" class="btn dialog-btn-secondary" (click)="close()">No</button>
                    <button matButton="filled" type="button" class="btn dialog-btn-primary"
                        (click)="confirmLogout()">Yes , Logout</button>
                </div>
            </form>
        </div>
    </mat-dialog-content>
</div>